module.exports = __webpack_public_path__ + "img/logo.af61fda6.png";